/**
 * Student Planner API — the student's own status on an assignment (slice 2).
 *
 * PUT    /v1/student-planner/assignments/:assignment_public_id/status  body `{ status }`
 * DELETE /v1/student-planner/assignments/:assignment_public_id/status  ("Use Blackbaud status")
 *
 * Self only: the subject is always the session student; any other id in the
 * request is ignored. Both respond with the assignment's resolved status, in
 * the Planner's lowercase vocabulary. The status is never sent to Blackbaud.
 */

import { z } from 'zod'

import {
  BlackbaudAssignmentStatusSchema,
  PlannerStatusSchema,
  PlannerStatusSourceSchema
} from '../../schemas/entities/planner-item'

export const PlannerStatusOverrideParamsSchema = z.object({
  /** Assignment publicId, as the feed's item `id`. */
  assignment_public_id: z.string().min(1)
})
export type PlannerStatusOverrideParams = z.infer<typeof PlannerStatusOverrideParamsSchema>

export const SetPlannerStatusOverrideBodySchema = z.object({
  status: PlannerStatusSchema
})
export type SetPlannerStatusOverrideBody = z.infer<typeof SetPlannerStatusOverrideBodySchema>

/** The assignment's status after the write, resolved exactly as the feed resolves it. */
export const PlannerStatusOverrideResultSchema = z.object({
  /** Assignment publicId. */
  id: z.string(),
  status: PlannerStatusSchema.nullable(),
  /** `student` while the student's own status is in effect. Null exactly when `status` is null. */
  statusSource: PlannerStatusSourceSchema.nullable(),
  isMissing: z.boolean(),
  blackbaudStatus: BlackbaudAssignmentStatusSchema.nullable()
})
export type PlannerStatusOverrideResult = z.infer<typeof PlannerStatusOverrideResultSchema>
